import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=aba30898&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=aba30898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba30898",
  null
  
)

export default component.exports